import styled from 'styled-components';

export const Bolder = styled.span`
  font-weight: 500;
`;
